import React, { useRef } from 'react';

import { Layout, message } from 'antd';
import cn from 'classnames';
import { NextPage } from 'next';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';

import { type SendAirdropReq, sendAirdrop } from '@api/index';
import Icon from '@components/Icon';
import { useClient } from '@lib/hooks'
import { I18n } from '@utils/index';
import { getGreeting, SelectBox, SendFormProps } from '@widget/airdrop';
import { useShare } from '@widget/airdrop/hooks/useShareAirdrop';
import { PageFooter } from '@widget/home/FooterNav';
import NavBar from '@widget/invitation/Navbar';
import { openSendAirdropModal } from '@widget/user/FundsPassword';

import styles from './index.module.less';
const { Header } = Layout;

const SendForm = dynamic(
  () => import('@widget/airdrop').then((module) => module.SendForm),
  { ssr: false }
);

const Page: NextPage = () => {
  const router = useRouter();
  const ref = useRef<HTMLDivElement>();
  const boxRef = useRef<Partial<Pick<SendAirdropReq, 'cover' | 'greeting'>>>();
  const isPC = useClient();
  const { shareOpen } = useShare();
  const goBack = () => {
    router.back();
  };
  const onSend: SendFormProps['onSubmit'] = async (params) => {
    const { tokenId } = await openSendAirdropModal({
      el: ref.current,
      router
    });
    if (!tokenId) return;
    const res = await sendAirdrop({
      ...params,
      tokenId,
      cover: boxRef.current?.cover,
      greeting: boxRef.current?.greeting || getGreeting()[boxRef.current?.cover]
    } as any);
    if (!res.success) {
      message.error(I18n.t(res.msgKey))
    } else {
      const airdropDetail = {
        ...res.obj
      }
      message.success(I18n.t('forgetPass_step_two_success'));
      /** 发送成功后分享空投 */
      const shareObj = {
        el: ref.current,
        ...airdropDetail
      }
      shareOpen(shareObj);
    }
    return {
      state: 'ok'
    };
  };

  return (
    <Layout className={styles.layout}>
      <Header className={styles.header}>
        <NavBar />
      </Header>
      <div className={styles.container} ref={ref}>
        <div className={styles.backrow} onClick={goBack} data-buried="go-back">
          <Icon className={styles.icon} name="left" />
          <span className={styles.back}>{I18n.t('gRJfKdS4')}</span>
        </div>
        <div className={styles.main}>
          {isPC && <div className={styles.left}>
            <SelectBox ref={boxRef} />
          </div>}
          <div className={styles.right}>
            <h2 className={cn(styles.title, 'medium')}>{I18n.t('r8zlV6z3')}</h2>
            { /* @ts-ignore */ }
            <SendForm onSubmit={onSend}>
              {!isPC && <SelectBox ref={boxRef} />}
            </SendForm>
          </div>
        </div>
      </div>
      <PageFooter theme="dark" />
    </Layout>
  );
};

export default Page;
